import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../shared/shared.module';

const routes: Routes = [
  { path: 'prijava', loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule) },
  { path: 'registracija', loadChildren: () => import('./register/register.module').then(m => m.RegisterPageModule) },
  { path: 'pozabljeno-geslo', loadChildren: () => import('./forgotten-password/forgotten-password.module').then(m => m.ForgottenPasswordPageModule) },
  { path: 'ponastavitev', loadChildren: () => import('./set-new-password/set-new-password.module').then(m => m.SetNewPasswordPageModule) },
];

@NgModule({
  imports: [
    SharedModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
  ]
})
export class AuthModule {}